module.exports = __webpack_public_path__ + "static/media/TEMPLATE3.6c6b54b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adtemplates/TEMPLATE3.jpg
// module id = 1469
// module chunks = 1